<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
            <!-- <el-form-item label="ID">
        <el-input v-model="queryForm.id"></el-input>
      </el-form-item> -->
            <el-form-item label="卡片额度">
                <el-input v-model="queryForm.money"></el-input>
            </el-form-item>

            <!-- <el-form-item label="时间范围">
                <el-date-picker
                    v-model="addtimeRange"
                    style="width: 180px"
                    type="datetimerange"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="-"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                >
                </el-date-picker> -->
            <!-- </el-form-item> -->

            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getShopCardBlackgoldList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button type="primary" size="small" icon="el-icon-plus" @click="addShopCardBlackgold">新建</el-button>
                    <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editShopCardBlackgold(null)"
                        >修改</el-button
                    >
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteShopCardBlackgold(null)"
                        >删除</el-button
                    >
                </div>

                <div class="icon-group">
                    <span title="搜索" class="icon-box" @click="search">
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <!-- <span title="下载模板" class="icon-box" @click="importTemplate">
            <Icon color="#606266">
              <ArrowDown />
            </Icon>
          </span> -->
                    <!-- <span class="icon-box" title="导入数据" @click="isImport">
            <Icon color="#606266">
              <ArrowExportUp24Regular />
            </Icon>
          </span> -->
                    <!-- <span title="导出数据" class="icon-box" @click="exportShopCardBlackgoldList">
                        <Icon color="#606266">
                            <ArrowDownload24Regular />
                        </Icon>
                    </span> -->
                    <span class="icon-box" @click="refreshShopCardBlackgoldList">
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="shopCardBlackgoldList"
                row-key="id"
                border
                :header-row-style="{ height: '10px' }"
                :header-cell-style="{ padding: '10px' }"
                :row-style="{ height: '9px' }"
                :cell-style="{ padding: '9px' }"
                @selection-change="handleSelectionChange"
                size="small"
                height="100%"
            >
                <el-table-column align="center" type="selection" width="60"> </el-table-column>

                <el-table-column :show-overflow-tooltip="true" align="center" prop="coverPic" label="卡片封面" width="180">
                    <template slot-scope="scope">
                        <div v-if="scope.row.coverPic">
                            <div vertical-align:middle>
                                <img
                                    style="margin-left: 50%; transform: translate(-50%, 0)"
                                    :src="scope.row.coverPic"
                                    alt=""
                                    class="w-28 h-21 log-img"
                                />
                            </div>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="money" label="卡片额度" width="180"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="expiredTime" label="过期时间(年)" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="createTime" label="创建时间"> </el-table-column>
                <el-table-column fixed="right" align="center" label="操作" width="200">
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="checkShopCardBlackgold(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editShopCardBlackgold(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteShopCardBlackgold(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div> -->
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="shopCardBlackgoldStates[shopCardBlackgoldState]"
                :visible.sync="showDialog"
                width="400px"
                :modal='false'
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="shopCardBlackgold"
                        ref="shopCardBlackgoldForm"
                        :rules="rules"
                        label-width="120px"
                        :inline="true"
                        size="small"
                    >
                        <el-form-item label="卡片额度" prop="money" label-width="80px">
                            <el-input
                                size="small"
                                v-model.number="shopCardBlackgold.money"
                                :disabled="shopCardBlackgoldState == 'check'"
                                style="width: 200px"
                            ></el-input>
                        </el-form-item>

                        <el-form-item label="销售价格" prop="money" label-width="80px">
                            <el-input
                                size="small"
                                v-model.number="shopCardBlackgold.price"
                                :disabled="shopCardBlackgoldState == 'check'"
                                style="width: 200px"
                            ></el-input>
                        </el-form-item>

                        <el-form-item label="卡片封面" prop="coverPic" label-width="80px">
                            <el-upload
                                action=""
                                :disabled="shopCardBlackgoldState == 'check'"
                                class="avatar-uploader"
                                :show-file-list="false"
                                :http-request="uploadAvatar"
                                style="width: 200px"
                            >
                                <img v-if="shopCardBlackgold.coverPic" :src="shopCardBlackgold.coverPic" class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>

                        <el-form-item label="过期时间" prop="expiredTime" label-width="80px">
                            <el-input-number
                                :disabled="shopCardBlackgoldState == 'check'"
                                v-model="shopCardBlackgold.expiredTime"
                                :min="1"
                                style="width: 200px"
                                label="描述文字"
                            ></el-input-number>
                            <!-- <el-input
                                style="width: 200px"
                                :disabled="shopCardBlackgoldState == 'check'"
                                v-model.number="shopCardBlackgold.expiredTime"
                            ></el-input> -->
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="flex justify-end">
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button type="primary" @click="submitForm" v-if="shopCardBlackgoldState != 'check'">确定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopCardBlackgoldList();
                this.getShopCardBlackgoldList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopCardBlackgoldList();
                this.getShopCardBlackgoldList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            shopProductCategory: {
                categoryPic: '' //类别图片
            },
            addtimeRange: [], //范围时间
            // 购物卡下拉菜单
            value: '',
            queryForm: {
                // id: '', //ID
                money: '', //额度
                coverPic: '', //封面
                expiredTime: '' //过期时间
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopCardBlackgoldState: 'add',
            shopCardBlackgoldStates: {
                add: '新建购物卡',
                check: '查看购物卡',
                edit: '修改购物卡'
            },

            multipleSelection: [],
            shopCardBlackgoldList: [],
            shopCardBlackgold: {
                // id: '', //ID
                money: '', //额度
                coverPic: '', //封面
                expiredTime: '', //过期时间
                price: '',
            },
            btnLoading: false,
            rules: {
                money: [
                    { required: true, message: '卡片额度不能为空', trigger: 'blur' },
                    { type: 'number', message: '卡片额度必须为数字值' }
                ],
                price: [{ required: true, message: '销售价格不能为空', trigger: 'blur' }],
                coverPic: [{ required: true, message: '卡片封面不能为空', trigger: 'blur' }],
                expiredTime: [
                    { required: true, message: '过期时间不能为空', trigger: 'blur' },
                    { type: 'number', message: '过期时间必须为数字值' }
                ]
            }
        };
    },
    created() {
        this.getShopCardBlackgoldList();
    },
    methods: {
        uploadAvatar(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!types.includes(file.type)) {
                this.$message({
                    message: '只能上传图片格式的文件，png.jpg或者jpeg',
                    type: 'error',
                    showClose: true,
                    duration: 2000
                });
            }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(`/mpp/image/upload`, formData).then((res) => {
                console.log({ res });
                if (res.success) {
                    this.shopCardBlackgold.coverPic = res.url;
                }
            });
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopCardBlackgoldList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopCardBlackgoldList = [];
        },
        resetDialog() {
            this.shopCardBlackgoldState = 'add';
            this.showDialog = false;
            this.queryForm = {
                // id: '', //ID
                money: '', //额度
                coverPic: '', //封面
                expiredTime: '' //过期时间
            };
            this.addtimeRange = [];
            this.getShopCardBlackgoldList();
        },
        closeDialog() {
            this.showDialog = false;
            this.shopCardBlackgold = {
                // id: '', //ID
                money: '', //额度
                coverPic: '', //封面
                expiredTime: '', //过期时间
                price: ''
            };
            this.$refs.shopCardBlackgoldForm.resetFields();
        },
        submitForm() {
            if (this.shopCardBlackgoldState == 'add') {
                this.$refs.shopCardBlackgoldForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/shop/shopcardshopping/add`, { ...this.shopCardBlackgold }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopCardBlackgoldList();
                                this.resetDialog();
                                this.getShopCardBlackgoldList();
                            }
                        });
                    }
                });
            } else if (this.shopCardBlackgoldState == 'edit') {
                this.$refs.shopCardBlackgoldForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/shop/shopcardshopping/edit`, { ...this.shopCardBlackgold }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopCardBlackgoldList();
                                this.resetDialog();
                                this.getShopCardBlackgoldList();
                            }
                        });
                    }
                });
            }
            // this.showDialog = false;
        },
        addShopCardBlackgold() {
            this.showDialog = true;
            this.shopCardBlackgoldState = 'add';
        },
        checkShopCardBlackgold(shopCardBlackgoldId) {
            console.log(shopCardBlackgoldId);
            this.currentShopCardBlackgoldId = shopCardBlackgoldId;

            this.getShopCardBlackgoldById();
            this.showDialog = true;
            this.shopCardBlackgoldState = 'check';
        },
        editShopCardBlackgold(shopCardBlackgoldId) {
            console.log('shopCardBlackgold', shopCardBlackgoldId);
            if (shopCardBlackgoldId) {
                this.currentShopCardBlackgoldId = shopCardBlackgoldId;
                this.getShopCardBlackgoldById();
            } else {
                this.shopCardBlackgold = { ...this.shopCardBlackgold, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.shopCardBlackgoldState = 'edit';
        },
        deleteShopCardBlackgold(shopCardBlackgoldId) {
            let ids = '';
            if (shopCardBlackgoldId) {
                ids = shopCardBlackgoldId;
            } else {
                ids = this.multipleSelection.map((shopCardBlackgold) => shopCardBlackgold.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/shopcardshopping/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopCardBlackgoldList();
                            this.getShopCardBlackgoldList();
                        }
                    });
                })
                .catch(() => {});
        },
        refreshShopCardBlackgoldList() {
            this.resetShopCardBlackgoldList();
            this.getShopCardBlackgoldList();
        },
        getShopCardBlackgoldList(query = {}) {
            // this.queryForm.startAddtime = '';
            // this.queryForm.endAddtime = '';
            // if (this.addtimeRange != null) {
            //     this.queryForm.startAddtime = this.addtimeRange[0];
            //     this.queryForm.endAddtime = this.addtimeRange[1];
            // }
            this.loading = true;
            get(`/shop/shopcardshopping/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    console.log(res);
                    this.shopCardBlackgoldList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        getShopCardBlackgoldById() {
            get(`/shop/shopcardshopping/get`, { id: this.currentShopCardBlackgoldId }).then((res) => {
                if (res.success) {
                    this.shopCardBlackgold = { ...this.shopCardBlackgold, ...res.shopCardCash };
                    console.log(this.shopCardBlackgold);
                }
            });
        },
        /**
         * 导出信息
         */
        exportShopCardBlackgoldList() {
            //this.btnLoading = true;
            exprotExcel(`/shop/shopcardshopping/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        // importTemplate() {
        //     this.btnLoading = true;
        //     importTemplate(`/shop/shopcardshopping/importTemplate`, this.btnLoading);
        // },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/shop/shopcardshopping/importData`, formData);
            this.refreshShopCardBlackgoldList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopCardBlackgoldList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopCardBlackgoldList();
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
// .el-upload {
//     width: 200px !important;
// }
::v-deep .el-upload--text {
    width: 200px;
}
// ::v-deep .log-img {
//     margin: 0 auto;
// }
.el-icon-plus {
    margin-top: 38%;
    font-size: 25px;
}
// ::v-deep .el-table__body-wrapper{
//     height: 484px;
// }
</style>
